import { Category } from "../Category.js";

export const categoryAnchorsMap: Record<Category, string> = {
	[Category.Cranes]: "cranes",
	[Category.Racks]: "racks",
	[Category.Robots]: "robots",
	[Category.VertinodeAi]: "vertinode",
};
